export default __webpack_public_path__ + "static/media/Bloch.05d68579.png";